import { parseTime } from '@/utils/util'
export const searchForm = {
  auto_state: '0', // 0待审核 1通过 2重新匹配
  line_id: undefined,
  id: null, // 标签序号
  label_name: null, // 标签名称
}

export const searchFormArticle = {
  article_title: '',
  article_id: undefined
}

export const form = {
  line_id: undefined, // 业务线id
  title: '', // 专题标题
  head_img: '', // 专题头图
  release_time: '', // 发布时间
  content: '', // 专题内容
}

export const formArticle = {
  article: [], // 文章id
}

export const rules = {
  line_id: [{ required: true, message: '请选择业务线', trigger: 'change' }],
  title: [{ required: true, message: '请输入专题标题', trigger: 'change' }],
  head_img: [{ required: true, message: '请上传专题头图', trigger: 'change' }],
  release_time: [{ required: true, message: '请选择发布时间', trigger: 'change' }],
  content: [{ required: true, message: '请输入专题内容', trigger: 'change' }],
}

export const rulesArticle = {
  article: [{ required: true, message: '请选择文章标题', trigger: 'change' }],
}

export const columns = [
  {
    title: '标签序号',
    dataIndex: 'id',
    width: 80,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'project',
    width: 200,
    align: 'left',
    scopedSlots: { customRender: 'project' }
    // customRender(text, record) {
    //   const line = `${record.project}-${record.type}-${record.staff_style}`
    //   return line
    // }
  },
  {
    title: '标签名称',
    dataIndex: 'label_name',
    width: 200,
    align: 'left',
  },
  {
    title: '已上架文章数量',
    dataIndex: 'article_total',
    align: 'left',
    width: 100,
    scopedSlots: { customRender: 'article_total' }
  },
  {
    title: '匹配文章数量',
    dataIndex: 'autoArticle',
    width: 100,
    align: 'left',
    scopedSlots: { customRender: 'autoArticle' }
  },
  {
    title: '匹配时间',
    dataIndex: 'auto_article_at',
    align: 'center',
    width: 160,
    customRender(text) {
      text === 0 ? text = '--' : text = parseTime(text)
      return text
    }
  }
]

export const columnsArticle = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '标题',
    dataIndex: 'article',
    width: 160,
    align: 'left',
    scopedSlots: { customRender: 'title' }
  },
  {
    title: '文章分类',
    dataIndex: 'article.typeid',
    width: 100,
    align: 'left',
    scopedSlots: { customRender: 'typeid' }
  },
  {
    title: '发布时间',
    dataIndex: 'article.created_at',
    align: 'left',
    width: 120,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '发布人',
    dataIndex: 'article.add_person_name',
    width: 120,
    align: 'left',
    scopedSlots: { customRender: 'add_person_name' }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 50,
    scopedSlots: { customRender: 'operator' }
  }
]

export const viewColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 80,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'project',
    width: 180,
    align: 'left',
    scopedSlots: { customRender: 'project' }
  },
  {
    title: '标题',
    dataIndex: 'title',
    align: 'left',
    scopedSlots: { customRender: 'title' }
  },
  {
    title: '分类',
    dataIndex: 'articleTypeOne',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'articleTypeOne' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 100,
    align: 'left',
    scopedSlots: { customRender: 'operation' }
  }
]
